import { Paper, Text, Group } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'

export function DataCaveatBanner({ caveat }) {
  if (!caveat) return null

  return (
    <Paper
      p="sm"
      style={{
        background: 'rgba(0, 229, 255, 0.04)',
        border: '1px solid rgba(0, 229, 255, 0.12)',
        borderRadius: 8,
      }}
    >
      <Group gap="sm" wrap="nowrap" align="flex-start">
        <IconInfoCircle
          size={16}
          color="var(--mantine-color-cyan-5)"
          style={{ flexShrink: 0, marginTop: 2 }}
        />
        <Text size="xs" c="dimmed" lh={1.5}>
          {caveat}
        </Text>
      </Group>
    </Paper>
  )
}
